import { useState } from 'react'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'
import app, { FlashType } from 'modules/core/store/models/app'

const showFlashMessage = (type: FlashType, message: string) => {
  app.setFlash({
    type,
    message,
  })
}

export const useSendInvitation = (employeeId: number, accessId: number) => {
  const [invitationSent, setInvitationSent] = useState(false)
  const [invitationSentToUsers, setInvitationSentToUsers] = useState<number[]>([])

  useEffect(() => {
    setInvitationSent(false)
  }, [employeeId])

  const { running, performAction } = useAsyncAction(async () => {
    const api = ApiClient()

    try {
      await api.post('/invitations', {
        access_id: accessId,
      })

      setInvitationSent(true)
      setInvitationSentToUsers([...invitationSentToUsers, accessId])

      showFlashMessage('correct', i18n.t('employees.invitation_sent'))
    } catch (error) {
      if (typeof error !== 'object' || error === null) {
        throw error
      }

      const errors = JSON.parse(JSON.stringify(error))

      if (!('payload' in errors) || !('messages' in errors.payload)) {
        throw error
      }

      const errorMessage = errors.payload.messages

      showFlashMessage('wrong', errorMessage)
    }
  })

  return {
    invitationSent,
    invitationSentToUsers,
    running,
    performAction,
  }
}
